import { PromotionContentEntityService } from '@views/pages/apps/general/promotion-contents/services/promotion-content-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';

@Injectable()
export class PromotionContentResolver implements Resolve<boolean> {

    constructor(private promotionContentEntityService: PromotionContentEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.promotionContentEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.promotionContentEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
